module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "thumb-example"
  }, [(_vm.swiperReset) ? _c('swiper', {
    ref: "swiperTop",
    staticClass: "swiper gallery-top",
    attrs: {
      "options": _vm.swiperOptionTop
    }
  }, [_vm._l((_vm.bigImg), function(item) {
    return _c('swiper-slide', {
      key: item.id,
      staticClass: "slide-1"
    }, [_c('div', {
      staticClass: "slide-1-box"
    }, [_c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": item.src,
        "alt": ""
      }
    })])])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next swiper-button-white",
    attrs: {
      "slot": "button-next"
    },
    slot: "button-next"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev swiper-button-white",
    attrs: {
      "slot": "button-prev"
    },
    slot: "button-prev"
  })], 2) : _vm._e(), _vm._v(" "), (_vm.swiperReset) ? _c('swiper', {
    ref: "swiperThumbs",
    staticClass: "swiper gallery-thumbs",
    attrs: {
      "options": _vm.swiperOptionThumbs
    }
  }, _vm._l((_vm.bigImg), function(item) {
    return _c('swiper-slide', {
      key: item.id,
      staticClass: "slide-thumb-item",
      staticStyle: {
        "height": "100px"
      },
      style: ({
        'width': _vm.thumbsWidth + '%'
      })
    }, [_c('img', {
      staticStyle: {
        "width": "100%",
        "height": "100px"
      },
      attrs: {
        "src": item.src,
        "alt": ""
      }
    })])
  }), 1) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-822e2e2a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/Gallery.vue
// module id = 80
// module chunks = 0